export default [{"id":"1","startTime":0,"endTime":3591,"text":"<b>Dieser Aufsatz wird nun auf dem Unterteil montiert.</b>"}];